module.exports = __webpack_public_path__ + "img/send_success.944461bb.png";